import { patchUserAuthority } from "@erp/shared/api/generated/wrappers/user";
import { useInvalidateQueries } from "@erp/shared/composables/useInvalidateQueries";
import { queries } from "@erp/shared/queries";
import { showAlert } from "@erp/shared/utils/dialog";
import { getErrorMessage } from "@erp/shared/utils/error";
import { useMutation, useQuery } from "@tanstack/vue-query";
export const useAuthorizationAction = () => {
    const { invalidateQueries } = useInvalidateQueries();
    const readAuthoritys = useQuery(queries.user.authoritys());
    const readUserAuthority = useQuery(queries.user.userAuthority());
    const updateUserAuthority = useMutation({
        mutationFn: ({ userId, groupIds, }) => patchUserAuthority(userId, groupIds),
        onSuccess: () => {
            showAlert("권한 수정 완료", "완료");
            invalidateQueries([
                queries.user._def,
            ]);
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "권한 수정 실패");
        },
    });
    return {
        readAuthoritys,
        readUserAuthority,
        updateUserAuthority,
    };
};
